import React from "react";
import Select from 'react-select';
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

import ApiUiController from "../../controller/ApiUiController";
import Constants from "../../util/Constants";
import FieldController from "../../controller/FieldController";

class KanbanPopup extends React.Component {
  constructor(props) {
    super(props);
    this.groupByOptions = this.getFilteredFieldsOptions();
    this.state = { inApiCall: false, name: "", groupBy: null, validated: false, errors: { name: "", groupBy: "" } };
  }

  getFilteredFieldsOptions() {
    const fields = Object.values(this.props.model?.fields ?? {});
    const filteredFields = fields.filter(
      field => field?.field_type?.startsWith(Constants.Select)
    );


    const options = filteredFields.map((field) => {
      const hiddenOptions = FieldController.getOptions(field);
      if(!field.field_key || !field.label_name || field.field_key === "created_by" || field.field_key === "updated_by" || !(hiddenOptions ?? []).length) return null
      return { value: field.field_key, label: field.label_name }
    }).filter(Boolean);
    return options
  }

  onNameChange = ( event ) => {
    this.setState(prev => ({ ...this.state, name: event.target.value, errors: { ...prev.errors, name: prev.errors.name ? "" : "" }}));
  }

  onChangeGroupBy = ( val ) => {
    this.setState(prev => ({...this.state, groupBy: val, errors: { ...prev.errors, groupBy: prev.errors.groupBy ? "" : "" } }));
  }

  onSave = () => {
    const errors = {};
    if (!this.state?.name?.trim()) errors.name = "Name is required";
    if (!this.state?.groupBy?.value?.trim()) errors.groupBy = "Group By is required";
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.props?.onCreate({ value: this.state.groupBy?.value, label: this.state.name });
    this.setState({ ...this.state, name: "", groupBy: null });
  }

  render() {
    return (
      <Modal aria-labelledby="contained-modal-title-vcenter" size="sm" show={this.props.show}
        onHide={this.props.onHide} centered  className="w-660">

        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {/* {this.props?.call ? 'Update' : 'Add' } {this.model.model_name} :     {Display.ModelName(this.props.lead || this.props.contact)} */}
            Add Kanban View
          </Modal.Title>
        </Modal.Header>

        <ApiUiController inApiCall={this.state.inApiCall}>
          <Modal.Body>
            <Form>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control required type="text" placeholder="Name"
                    className="mr-sm-2" value={this.state.name}
                    onChange={this.onNameChange} />
                  {this.state.errors?.name && (
                    <div style={{ color: "red", fontSize: "0.8rem", marginTop: "0.25rem" }}>{this.state.errors.name}</div>
                  )}
                </Col>
              </Row>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Group By</Form.Label>
                  <Select required value={this.state.groupBy} options={this.groupByOptions}
                    onChange={this.onChangeGroupBy} />
                  {this.state.errors?.groupBy && (
                    <div style={{ color: "red", fontSize: "0.8rem", marginTop: "0.25rem" }}>{this.state.errors.groupBy}</div>
                  )}
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer><Button onClick={this.onSave}>Submit</Button></Modal.Footer>
        </ApiUiController>
      </Modal>
    );
  }
}

export default KanbanPopup;